<template>
<div class="hintbox">
  <el-button class='hintbox-holder' v-show='!full' @click="full = true">常见问题</el-button>

  <div class="hintbox-full" v-show="full">
    <div class="title">
      <span>常见问题</span>
      <span class='hint'>QQ群：461571276</span>
      <a class='block-btn' @click="full = false"><i class='ppj-icon-cancel'></i></a>
    </div>
    <div class="content">
      <ul>
        <li><a href="https://ppj.kf5.com/hc/kb/article/1062142/" target="_blank">如何使用微信录制语音微课</a></li>
        <li><a href="http://ppj.io/docs/#/createQuiz" target="_blank">如何在PPT中插入答题，制作小测验？</a></li>
        <li><a href="http://ppj.io/docs/#/createForm" target="_blank">如何插入表单，实现数据搜集</a></li>
        <li><a href="http://ppj.io/docs/#/size" target="_blank">如何制作竖版PPT</a></li>
      </ul>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      full: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
.hintbox {
    .hintbox-holder {
        position: fixed;
        bottom: 0;
        right: 60px;
        color: $color-white-base;
        font-weight: $font-weight-border;
        background-color: $color-black-base;
        border: none;
        z-index: $index-top;
        &:focus,
        &:hover {
            color: $color-white-base;
        }
    }

    .hintbox-full {
        width: 300px;
        position: fixed;
        padding-bottom: 0;
        bottom: 0;
        z-index: $index-top;
        right: 30px;
        border: $border-base;
        border-radius: 2px;
        background-color: $color-white-base;
        box-shadow: $box-shadow-dark;

        .title {
            line-height: $font-size-large;
            font-size: 16px;
            padding: 15px 15px 10px;
            color: $font-color-strong;
            font-weight: $font-weight-border;
            border-bottom: $border-base;

            .hint {
                color: $font-color-light;
                font-size: $font-size-base;
                font-weight: $font-weight-base;
                margin-left: 1em;
            }

            .block-btn {
                float: right;
                &:hover {
                    color: $font-color-strong;
                }
            }
        }

        .content {
            line-height: 1.5;
        }
    }
}
</style>



// WEBPACK FOOTER //
// hintbox.vue?097c0f02